import Grace from 'components/grace';
import { CustomerReportProvider } from 'components/grace/Contexts';

const GraceWrapper = () => {
  return (
    <CustomerReportProvider>
      <Grace />
    </CustomerReportProvider>
  );
};

export default GraceWrapper;
